import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { primeiraLetraPalavraUpperCase, getArrayStatusFormatted, getTipoPerfil } from 'utils/funcaoPadrao';
import { STATUS_REQUERIMENTO } from 'utils/consts';

export const calcularPorcentagem = (valor, dadosGrafico) => {
  const array = [];
  Object.keys(dadosGrafico).forEach(key => array.push(dadosGrafico[key]));
  const valorTotal = array.reduce((a, b) => a + b, 0);
  return ((valor * 100) / valorTotal).toFixed(2);
};

export const montarArrayExibir = (dadosGrafico, perfilUsuario) => {
  const array = [];
  Object.keys(dadosGrafico).forEach(key => {
    const novoObjeto = getArrayStatusFormatted().find(x => x.descricao === key);
    novoObjeto.valor = dadosGrafico[key];
    novoObjeto.porcentagem = calcularPorcentagem(dadosGrafico[key], dadosGrafico);
    if (
      (perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL &&
        novoObjeto?.nomeKey !== STATUS_REQUERIMENTO.ABERTO.identificador) ||
      perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR
    )
      array.push(novoObjeto);
  });

  const valorSomaTotal = array.reduce((a, b) => a + b.valor, 0);
  if (valorSomaTotal === 0) {
    return [
      {
        id: 0,
        valor: 0,
        porcentagem: '100',
        descricao: 'Sem valor',
        cor: '#f5f5f5',
        borderColor: '#bfbfbf',
      },
    ];
  }
  return array;
};

export const montarGraficoPizza = (dadosGrafico, perfilUsuario) => {
  const valores = [];
  const label = [];
  const cor = [];
  const borderColor = [];
  montarArrayExibir(dadosGrafico, perfilUsuario).forEach(item => {
    valores.push(item.porcentagem);
    label.push(item?.descricao);
    cor.push(item?.cor);
    borderColor.push(item?.borderColor);
  });

  return {
    labels: label,
    datasets: [
      {
        label: '',
        data: valores,
        backgroundColor: cor,
        borderColor: borderColor,
        borderWidth: 1,
      },
    ],
  };
};

export const descricao = (nomeUsuario, perfil) =>
  `Olá ${primeiraLetraPalavraUpperCase(nomeUsuario)}, seu perfil atual é de ${getTipoPerfil(perfil)}, você ` +
  `está autenticado pelo eSefaz, agora você pode visualizar ` +
  `e acompanhar as situações dos requerimentos.`;
